/**
 * @generated SignedSource<<c3c57e9f8b405885083c13d18c3887a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utils_PaymentOption$data = {
  readonly total: {
    readonly amount: number;
  };
  readonly installments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly interestRate: number;
        readonly total: {
          readonly amount: number;
        };
        readonly value: {
          readonly amount: number;
        };
      };
    }>;
  };
  readonly " $fragmentType": "utils_PaymentOption";
};
export type utils_PaymentOption$key = {
  readonly " $data"?: utils_PaymentOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_PaymentOption">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "utils_PaymentOption"
};

(node as any).hash = "5c21e9e3620701ced978c0a8f198a349";

export default node;
